import React from "react";

const GoldenBuzzer = () => {
  return (
    <div className="w-full h-screen fixed top-0 left-0">
      <div className="h-full  w-full relative">
        <video
          className="w-full h-full object-cover top-0  absolute"
          src="/logo-motions/golden-buzzer_1.mp4"
          autoPlay
          
          muted
          playsInline
        />
      </div>
    </div>
  );
};

export default GoldenBuzzer;
